// extracted by mini-css-extract-plugin
export default {"propertyRow":"PropertyRow_propertyRow__TwB+Z","label":"PropertyRow_label__zMRlw","value":"PropertyRow_value__iJDz9","emphasized":"PropertyRow_emphasized__kvGSL"};